import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RmaUrlsService } from '@rma/generic/util/environment';
import { Observable } from 'rxjs';
import { BlogCategory, BlogList, BlogPost } from '../domain';

@Injectable({
  providedIn: 'root',
})
export class BlogService {
  constructor(
    private readonly http: HttpClient,
    private readonly rmaUrls: RmaUrlsService,
  ) {}

  public getPost(slug: string): Observable<BlogPost> {
    const url = this.rmaUrls.apiUrl(`wp/post/${slug}`);
    return this.http.get<BlogPost>(url);
  }

  public getAllPosts(page): Observable<BlogList> {
    const url = this.rmaUrls.apiUrl(`wp/posts?orderby=date&order=desc&perpage=9&page=${page}`);
    return this.http.get<BlogList>(url);
  }

  public getAllCategories(): Observable<BlogCategory[]> {
    return this.http.get<BlogCategory[]>(this.rmaUrls.apiUrl('wp/categories'));
  }

  public getPostsByCategorySlug(slug: string, page: number, perPage: number): Observable<BlogList> {
    const url = this.rmaUrls.apiUrl(`wp/posts/category/${slug}?orderby=date&order=desc&perpage=${perPage}&page=${page}`);
    return this.http.get<BlogList>(url);
  }
}
